import type { PageQuery } from "../../types/api.types.js";

const DRILLDOWN_METRIC_FILTERS: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  "open-complaints": { status: "open", dashboardMetric: "open-complaints" },
  "overdue-complaints": { slaState: "overdue", dashboardMetric: "overdue-complaints" },
  "sla-breached": { slaState: "breached", dashboardMetric: "sla-breached" },
  "rca-pending": { stage: "rca", status: "pending", dashboardMetric: "rca-pending" },
  "capa-pending": { stage: "capa", status: "pending", dashboardMetric: "capa-pending" },
  "verification-pending": { stage: "verification", status: "pending", dashboardMetric: "verification-pending" },
};

const ALLOWED_FILTER_KEYS = new Set([
  "status", "stage", "sourceId", "typeId", "categoryId", "subcategoryId", "severityId", "priorityId", "departmentId", "siteId", "ownerId", "assigneeId", "createdFrom", "createdTo", "dueFrom", "dueTo", "slaState", "confidentiality", "dashboardDrilldownKey", "dashboardMetric",
]);

export function cmtsComplaintDrilldownFilterFromSearch(searchParams: URLSearchParams): PageQuery {
  const filters: Record<string, string> = {};
  const metric = readParam(searchParams, "metric");
  if (metric) Object.assign(filters, DRILLDOWN_METRIC_FILTERS[metric] ?? { dashboardMetric: metric });
  for (const [key, value] of searchParams.entries()) {
    if (!value.trim()) continue;
    if (ALLOWED_FILTER_KEYS.has(key)) filters[key] = value.trim();
  }
  if (metric && !filters.dashboardDrilldownKey) filters.dashboardDrilldownKey = metric;
  const page = positiveInt(readParam(searchParams, "page")) ?? 1;
  const pageSize = positiveInt(readParam(searchParams, "pageSize")) ?? 25;
  const search = readParam(searchParams, "search");
  const sortBy = readParam(searchParams, "sortBy") ?? "updatedAt";
  const sortDirection = readParam(searchParams, "sortDirection") === "asc" ? "asc" : "desc";
  return { page, pageSize, search, sortBy, sortDirection, filters };
}

function readParam(params: URLSearchParams, key: string): string | undefined {
  const value = params.get(key);
  return value && value.trim() ? value.trim() : undefined;
}

function positiveInt(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}
